import { BuilderContent } from '@builder.io/react';
import classNames from 'classnames';
import { FC } from 'react';

import BusinessButton from '@/components/business-button/business-button';
import { COLORS } from '@/components/business-button/business-button.constants';

import { B2BTopNavigationMenuItem } from './b2b-top-navigation-menu-item';
import styles from './business-hub-primary-actions.module.scss';
import { BusinessSignUpButton } from '../business-sign-up-button/business-sign-up-button';

interface Props {
    isMobile?: boolean;
    isMobileMenuActive?: boolean;
    signupLink?: string;
    page: any;
}

export const BusinessHubPrimaryActions: FC<Props> = (props) => {
    const { page, signupLink, isMobile, isMobileMenuActive } = props;

    return (
        <div className={classNames(styles.container)}>
            <div className={classNames(styles.menuItems, { [styles.active]: isMobileMenuActive })}>
                <B2BTopNavigationMenuItem />
            </div>
            <BusinessSignUpButton page={page} isMobile={isMobile} signupLink={signupLink} />
        </div>
    );
};
